import React, { createContext, memo, useContext, useMemo } from 'react';
import isEqual from 'react-fast-compare';
const DropdownContext = createContext(undefined);
export const DropdownProvider = memo(({ open, children }) => {
    const value = useMemo(() => ({
        open,
    }), [open]);
    return (React.createElement(DropdownContext.Provider, { value: value }, children));
}, isEqual);
export const useDropdown = () => {
    const context = useContext(DropdownContext);
    if (context === undefined) {
        throw new Error('useDropdown must be used within a DropdownProvider');
    }
    return context;
};
//# sourceMappingURL=DropdownContext.js.map